import React, { useEffect, useState } from 'react';
import axiosInstance from "../utils/axiosConfig";

const PrivacyPolicy = () => {
  const [privacy, setPrivacy] = useState('');

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const response = await axiosInstance.get("master/getprivacy");
        if (response.data && response.data.length > 0) {
          setPrivacy(response.data[0].name);
        }
      } catch (error) {
        console.error("Error fetching privacy policy:", error);
      }
    };

    fetchPolicy();
  }, []);

  return (
    <section className="py-5" style={{ background: "#f5f7fa" }}>
      <div className="container">

        {/* HEADER */}
        <div className="text-center mb-4">
          <h2 className="fw-bold" style={{ color: "#222" }}>
            Privacy Policy
          </h2>
          <p className="text-muted">
            Learn how we collect, use, protect, and manage your personal information.
          </p>
        </div>

        {/* CARD */}
        <div className="card shadow-sm border-0 rounded-4">
          <div className="card-body p-4">

            {/* SCROLLABLE CONTENT */}
            <div
              className="overflow-auto"
              style={{
                maxHeight: "500px",
                paddingRight: "5px"
              }}
              dangerouslySetInnerHTML={{ __html: privacy }}
            />

          </div>
        </div>

      </div>
    </section>
  );
};

export default PrivacyPolicy;
